import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MenuBarComponent } from '../../core/components/menu-bar/menu-bar.component';
import { FooterComponent } from '../../core/components/footer/footer.component';
import { Equipment, EquipmentService } from '../../core/services/equipment.service';

/**
 * A single product. The URL shape matches the old site (/equipment/:slug), so
 * links shared before the new site went live still land here.
 *
 * English-only by design, like the rest of the catalogue.
 */
@Component({
    selector: 'app-equipment-detail',
    imports: [MenuBarComponent, FooterComponent],
    templateUrl: './equipment-detail.component.html',
    styleUrl: './equipment-detail.component.scss',
})
export class EquipmentDetailComponent implements OnInit {
    equipment: Equipment | null = null;
    state: 'loading' | 'ready' | 'not-found' | 'error' = 'loading';

    /** The lightbox body; opened on click rather than living in the DOM. */
    @ViewChild('imageModal') imageModal?: TemplateRef<unknown>;

    constructor(
        private equipmentService: EquipmentService,
        private route: ActivatedRoute,
        private router: Router,
        private modalService: NgbModal,
    ) { }

    ngOnInit(): void {
        window.scrollTo({ top: 0, behavior: 'instant' });
        const slug = this.route.snapshot.paramMap.get('slug') || '';
        if (!slug) {
            this.state = 'not-found';
            return;
        }

        this.equipmentService.bySlug(slug).subscribe({
            next: (res) => {
                this.equipment = res?.equipment ?? null;
                this.state = this.equipment ? 'ready' : 'not-found';
            },
            // handleError rethrows { httpError, service }, so the status is nested
            error: (err) => {
                const status = err?.httpError?.status ?? err?.status;
                this.state = status === 404 ? 'not-found' : 'error';
            },
        });
    }

    public backToList(): void {
        this.router.navigate(['/equipment']);
    }

    /** Opens the product photo full size. Backdrop and Escape close it. */
    public openImage(): void {
        if (!this.equipment?.image || !this.imageModal) return;
        this.modalService.open(this.imageModal, {
            centered: true,
            size: 'lg',
            windowClass: 'equipment-image-modal',
        });
    }
}
